import React from 'react';
import {simplifyForHtmlId} from "../../Utils/transformer";

// TODO: Action Menu

interface ProjectCardProps {
    title?: string,
    subtitle?: string,
    children?: React.ReactNode,
    className?: string,
    id?: string,
    onClick?: () => void
}

/**
 * Card component.
 * @param title title of the card
 * @param subtitle subtitle of the card
 * @param children ReactNode children
 * @param className Additional classes to apply to the card
 * @param onClick Click handler
 * @constructor
 */
const OdxCard: React.FC<ProjectCardProps> = ({title, subtitle, children, className, onClick, id}) => {
    if (!id) id = "";
    return (
        <div id={"OdxCard_" + simplifyForHtmlId(id)} className={`odx-card--launch-tile odx-cdk-interactive odx-card ${className}`} onClick={onClick}>
            <div className="odx-card__container">
                <div className={"odx-card__content w-full"}>
                    {title && <div className={"odx-card__title !odx-title-5"}>{title}</div>}
                    <div className={"odx-card__subtitle"}>
                        {subtitle}
                    </div>
                    <div className={"odx-card__content"}>
                        {children}
                    </div>
                </div>
            </div>

        </div>
    )
}

export default OdxCard;